import { BaseError } from "@/domains/errors/kinds/BaseError";

export class VoiceSuggestionMissingAudioRecordingIdError extends BaseError {
  constructor({
    noteId,
    suggestionKind,
    capturedAudioId,
  }: {
    noteId: string;
    suggestionKind: string;
    capturedAudioId?: string;
  }) {
    super({
      message:
        "[NoteObservable.refineNoteSuggestion] Voice suggestion is missing audio_recording_id",
      info: {
        noteId,
        suggestionKind,
        ...(capturedAudioId ? { capturedAudioId } : {}),
      },
    });
  }
}
